// src/lib/layouts/applyPostLayoutField.ts
import { applyClipPosition } from './applyClipPosition';
import { applyClipRatioToRect } from './applyClipRatioToRect';
import { deriveClipPosition } from './deriveClipPosition';
import type { PostLayoutConfig, PostLayoutFieldValue } from './types';

/** Apply one settings-panel write onto a post-layout config. Satisfatorio
 *  clipRatio / clipPosition also keep a dragged `clipRect` in sync so the
 *  renderer (which prefers clipRect over clipPosition) actually moves. */
export function applyPostLayoutField(
  prev: PostLayoutConfig,
  key: string,
  value: PostLayoutFieldValue,
  isLandscape: boolean,
): PostLayoutConfig {
  if (prev.kind === 'satisfatorio' && key === 'clipRatio' && prev.clipRect) {
    const clipRect = applyClipRatioToRect(prev.clipRect, Number(value), isLandscape);
    return {
      ...prev,
      clipRatio: value,
      clipRect,
      clipPosition: deriveClipPosition(clipRect, isLandscape),
    } as PostLayoutConfig;
  }
  if (
    prev.kind === 'satisfatorio'
    && key === 'clipPosition'
    && (value === 'top' || value === 'bottom')
  ) {
    return { ...prev, ...applyClipPosition(prev.clipRect, value, isLandscape) } as PostLayoutConfig;
  }
  if (prev.kind === 'circulo' && key === 'backgroundMedia' && (value === 'image' || value === 'video')) {
    if (value === 'image') {
      return {
        ...prev,
        backgroundMedia: 'image',
        fillerUrl: undefined,
        fillerUrls: undefined,
        fillerRandomize: undefined,
        fillerFits: undefined,
        fillerPositions: undefined,
      } as PostLayoutConfig;
    }
    return { ...prev, backgroundMedia: 'video', backgroundUrl: undefined } as PostLayoutConfig;
  }
  return { ...prev, [key]: value } as PostLayoutConfig;
}
